export default __webpack_public_path__ + "static/media/haccp.7a9f7d78.png";